'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.validate = validate;
exports.jsonSchemaPropValidator = jsonSchemaPropValidator;

var _tv = require('tv4');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simple abstraction over tv4 (our json-schema validation library) that also logs an error to the console.
 * @param value
 * @param schema
 * @param {string} name
 */
function validate(value, schema) {
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    value = JSON.parse((0, _stringify2.default)(value));
    name = name || schema.title || schema.description || '';
    var valid = _tv.tv4.validate(value, schema);
    if (!valid) {
        if (window.Rollbar) {
            window.Rollbar.warning('The given data failed to validate', { name: name, schema: schema, checkedData: value });
        }
        console.error(name, _tv.tv4.error, { schema: schema, checkedData: value });
    }
    return valid;
}

/**
 * Creates a vue prop validator from the given schema.
 * @param {Object} schema
 * @param {string} name
 * @returns {function(*=): *}
 */
function jsonSchemaPropValidator(schema) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return function (value) {
        return validate(value, schema, name);
    };
}